export const smallScreenMixin = {
  data() {
    return {
      showAlertForSmallScreen: false,
    };
  },
  created() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.showAlertForSmallScreen = window.innerWidth < 1010;
    },
  },
};
